export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';